import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClearanceItemAssetBaseComponent } from './clearance-item-asset-base.component';
import { IAsset } from './asset.interface';

@Component({
    selector: 'clearance-image',
    standalone: false,
    templateUrl: 'clearance-item-image.component.html',
    styles: [`
        :host {
          display: block;
          flex: 0 0 auto;
          width: 88px;
          max-width: 33.333%;
          box-sizing: border-box;
          margin: 0 12px 12px 0;
        }
        :host > div {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        @media (max-width: 600px) {
          :host {
            max-width: 50%;
          }
        }
        .photo-stack {}
        .photo-stack img, 
        .photo-stack i {
          position: absolute;
          top: 0;
          left: 0;
          border: 1px solid rgba(0, 0, 0, 0.15);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
          transition: all 0.3s ease-out;
        }
        .photo-stack img:nth-child(1),
        .photo-stack i:nth-child(1) {
          z-index: 999;
        }
        .photo-stack img:nth-child(2),
        .photo-stack i:nth-child(2) {
        transform: translate3d(1%, -3%, 0) rotate3d(0,0,1,3deg);
          z-index:998
        }
        .photo-stack img:nth-child(3),
        .photo-stack i:nth-child(3) {
          transform: translate3d(2%, -4%, 0) rotate3d(0,0,1,4deg);
          z-index:997
        }
        .photo-stack img:nth-child(4),
        .photo-stack i:nth-child(4) {
          transform: translate3d(3%, -5%, 0) rotate3d(0,0,1,5deg);
          z-index:996
        }

        .photo-stack:hover img:nth-child(1),
        .photo-stack:hover i:nth-child(1) {
            transform: scale(1.02);
          }
          .photo-stack:hover img:nth-child(2),
          .photo-stack:hover i:nth-child(2) {
          transform: translate3d(30%, -40%, 0) rotate3d(0,0,1,25deg) ;
          }
          .photo-stack:hover img:nth-child(3),
          .photo-stack:hover i:nth-child(3) {
          transform: translate3d(70%, -60%, 0) rotate3d(0,0,1,45deg);
        }
        .photo-stack:hover img:nth-child(4),
        .photo-stack:hover i:nth-child(4) {
          transform: translate3d(110%, -60%, 0) rotate3d(0,0,1,65deg);
        }
    `]
})

export class ClearanceItemImageComponent extends ClearanceItemAssetBaseComponent implements IAsset {

    supportedImages: string[] = ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/webp', 'jpeg','jpg','png', 'bmp'];

    setDefaultAssetImage() {
        //TDO
        throw new Error("Method not implemented.");
    }
   
    //--IsActualImage
    get IsActualImage(): boolean {

        var fileType = this.assetItemForm.get('fileType').value;
        if (!this.supportedImages.find(f => f == fileType)) {
            return false;
        }

        return true;
    }

    get ciImageStyle() {
        var styleObject = { 
            'background-image': 'url(' + this.assetItemForm.get('fullUrl').value + ')'
        }
        // highlight: lime border (STG). Inline longhands beat img.selected { border: none }
        // so it can coexist with the amber outline. box-sizing:border-box keeps it in 80px.
        if (this.assetItemForm.get('highlighted').value) {
            styleObject['border-color'] = 'lime';
            styleObject['border-style'] = 'solid';
            styleObject['border-width'] = 'medium';
        }
        return styleObject;
    }
}